import { Box, Typography } from '@mui/material';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

function GmailLogo() {
  return (
    <svg width="30" height="24" viewBox="0 0 30 24" aria-hidden="true">
      <path d="M2 5.2 6.2 8.4V21H2z" fill="#4285F4" />
      <path d="M28 5.2 23.8 8.4V21H28z" fill="#34A853" />
      <path d="M2 5.2 6.1 2 15 8.8 23.9 2 28 5.2 15 15z" fill="#EA4335" />
      <path d="M6.2 8.4 15 15l8.8-6.6V21H6.2z" fill="#FBBC04" opacity=".18" />
    </svg>
  );
}

function OutlookLogo() {
  return (
    <svg width="30" height="30" viewBox="0 0 32 32" aria-hidden="true">
      <rect x="11" y="5" width="18" height="22" rx="2" fill="#1473E6" />
      <path d="M12 10h16l-8 6z" fill="#fff" opacity=".9" />
      <path d="M12 10v12l7-6zM28 10v12l-7-6z" fill="#fff" opacity=".72" />
      <rect x="2" y="8" width="16" height="18" rx="2" fill="#0A5BD7" />
      <text x="10" y="21" textAnchor="middle" fontSize="12" fontWeight="700" fill="#fff">O</text>
    </svg>
  );
}

export function ProviderLogo({ provider, size = 48 }) {
  const common = {
    width: size,
    height: size,
    borderRadius: '14px',
    display: 'grid',
    placeItems: 'center',
    flex: '0 0 auto',
  };

  if (provider === 'google') {
    return <Box sx={{ ...common, bgcolor: '#fff', border: '1px solid rgba(26,29,49,.12)' }}><GmailLogo /></Box>;
  }
  if (provider === 'microsoft') {
    return <Box sx={{ ...common, bgcolor: '#eef6ff', border: '1px solid rgba(20,115,230,.18)' }}><OutlookLogo /></Box>;
  }
  if (provider === 'yahoo') {
    return (
      <Box sx={{ ...common, bgcolor: '#f4efff', border: '1px solid rgba(96,1,210,.15)' }}>
        <Typography sx={{ color: '#6001d2', fontWeight: 900, fontSize: size * .34 }}>Y!</Typography>
      </Box>
    );
  }
  if (provider === 'icloud') {
    return <Box sx={{ ...common, bgcolor: '#f2f7ff', border: '1px solid rgba(80,150,230,.16)', color: '#4e9ee9' }}><CloudOutlinedIcon /></Box>;
  }
  return <Box sx={{ ...common, bgcolor: '#f1efe9', border: '1px solid rgba(26,29,49,.12)', color: '#575b74' }}><MailOutlineIcon /></Box>;
}
